export const TURNING_ON_OFFLINE_MODE = 'turning on offline mode';
